import React from "react";
import PropTypes from "prop-types";

// внутренняя → русская метка
const STATUS_LABELS = {
  processing:   "В обработке",
  to_warehouse: "В пути на склад",
  in_stock:     "На складе",
  in_transit:   "В пути",
  arrived:      "Прибыл",
  cancelled:    "Отменён",
};

const ProductStatus = ({ status, large = false }) => {
  const key = (status || "").trim().toLowerCase();
  const label = STATUS_LABELS[key] || "Неизвестно";

  return (
    <div className={`order-status ${key} ${large ? "large" : ""}`}>
      {label}
    </div>
  );
};

ProductStatus.propTypes = {
  status: PropTypes.string.isRequired,
  large: PropTypes.bool,
};

export default ProductStatus;
